import { useState } from 'react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    service: '',
    date: '',
    time: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate textarea character limit
    if (formData.message.length > 500) {
      setSubmitMessage('El mensaje no puede exceder 500 caracteres');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d5qtofutc768qf4bqd00', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString()
      });

      if (response.ok) {
        setSubmitMessage('¡Gracias! Tu mensaje ha sido enviado correctamente. Nos pondremos en contacto contigo pronto.');
        setFormData({
          full_name: '',
          email: '',
          phone: '',
          service: '',
          date: '',
          time: '',
          message: ''
        });
      } else {
        setSubmitMessage('Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      setSubmitMessage('Error de conexión. Por favor, verifica tu conexión a internet.');
    }

    setIsSubmitting(false);
  };

  return (
    <section id="contacto" className="py-20 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="text-white">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Contacta con Nosotros
            </h2>
            <p className="text-xl text-gray-300 mb-12 leading-relaxed">
              Estamos aquí para ayudarte las 24 horas del día, los 7 días de la semana. 
              Respondemos en menos de una hora.
            </p>

            <div className="space-y-8">
              {/* Phone */}
              <div className="flex items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Teléfono 24/7</div>
                  <a href="tel:+34614932797" className="text-white text-xl font-semibold hover:text-teal-400 transition-colors">
                    +34 614 932 797
                  </a>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="flex items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">WhatsApp</div>
                  <a href="https://wa.me/34614932797" className="text-white text-xl font-semibold hover:text-teal-400 transition-colors">
                    +34 614 932 797
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Email</div>
                  <a href="mailto:wearebusmalaga@gmail.com" className="text-white text-xl font-semibold hover:text-teal-400 transition-colors">
                    wearebusmalaga@gmail.com
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Dirección</div>
                  <div className="text-white text-xl font-semibold">
                    Calle Generación 15<br />
                    29196 Málaga, España
                  </div>
                </div>
              </div>

              {/* Hours */}
              <div className="flex items-center">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-gray-400 text-sm mb-1">Horario de Oficina</div>
                  <div className="text-white text-xl font-semibold">
                    Lun-Vie: 08:00 - 20:00
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-12 pt-8 border-t border-gray-700">
              <p className="text-gray-400 mb-4">Síguenos en redes sociales</p>
              <div className="flex space-x-4">
                <a href="#" className="w-12 h-12 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                  <i className="ri-facebook-fill text-white text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                  <i className="ri-instagram-line text-white text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                  <i className="ri-twitter-x-line text-white text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-700 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                  <i className="ri-linkedin-fill text-white text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Solicita Tu Presupuesto
            </h3>
            
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              {/* Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nombre Completo *
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  required
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  required
                />
              </div>

              {/* Service */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de Servicio
                </label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                >
                  <option value="">Seleccionar servicio</option>
                  <option value="aeropuerto">Traslado Aeropuerto</option>
                  <option value="ejecutivo">Servicio Ejecutivo</option>
                  <option value="grupos">Traslados Grupales</option>
                  <option value="tours">Tours Privados</option>
                  <option value="eventos">Eventos Especiales</option>
                  <option value="horas">Servicio por Horas</option>
                </select>
              </div>

              {/* Date and Time */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Fecha
                  </label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Hora
                  </label>
                  <input
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mensaje *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none"
                  placeholder="Cuéntanos más detalles sobre tu traslado..."
                  required
                />
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.message.length}/500 caracteres
                </div>
              </div>

              {/* Submit Message */}
              {submitMessage && (
                <div className={`p-4 rounded-lg text-sm ${
                  submitMessage.includes('Gracias') 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-red-100 text-red-700'
                }`}>
                  {submitMessage}
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 disabled:transform-none whitespace-nowrap"
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <i className="ri-loader-line animate-spin mr-2"></i>
                    Enviando...
                  </div>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-2"></i>
                    Enviar Solicitud
                  </>
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-white text-center mb-8">
            Nuestra Ubicación
          </h3>
          <div className="bg-white rounded-2xl p-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12787.492612745327!2d-4.4291!3d36.7196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72f7b4b8c7b7e7%3A0x7b5c6d7e8f9g0h1i!2sM%C3%A1laga%2C%20Spain!5e0!3m2!1sen!2ses!4v1700000000000!5m2!1sen!2ses"
              width="100%"
              height="400"
              className="rounded-xl border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;